import {useTranslation} from "react-i18next";
import {NavLink} from "react-router-dom";

export const Footer = () => {
    const {t} = useTranslation();

    return (
        <div style={{paddingTop: "5vh"}}>
            <nav className={"navbar navbar-expand-md navbar-light bg-light ng-scope"}>
                <ul className="nav navbar-nav mx-auto menu-text desktop">
                    {[
                        ["/video", t("video")],
                        ["/documents", t("documents")],
                        ["/contacts", t("contacts")],
                        ["/privacypolicy", t("privacypolicy")],
                    ].map(([path, text], i) => (
                        <li className="nav-item active me-2" key={i}>
                            <NavLink className={"nav-link "} to={path}>
                                {text}
                            </NavLink>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};